import { genericPost, genericPut, genericFilePost } from './apiService';
import { API_URL } from '../config/env';

// Kullanıcı bilgilerini getir
export const GetUser = async () => {
  try {
    const response = await genericPost(`${API_URL}Person/GetUser`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Ev arkadaşı tercihlerini güncelle
export const UpdateMate = async (data) => {
  try {
    const response = await genericPut(`${API_URL}Person/Update`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

// Kullanıcı bilgilerini güncelle
export const UpdateUser = async (data) => {
  try {
    const response = await genericPut(`${API_URL}Person/UpdateUser`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

// Şifre değiştir
export const ResetPassword = async (data) => {
  try {
    const response = await genericPut(`${API_URL}Person/ResetPassword`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

// Profili gizle
export const UserHideProfile = async () => {
  try {
    const response = await genericPut(`${API_URL}Person/UserHideProfile`, null);
    return response;
  } catch (error) {
    throw error;
  }
};

// Hesabı sil
export const UserDeleteAccount = async () => {
  try {
    const response = await genericPut(`${API_URL}Person/UserDeleteAccount`, null);
    return response;
  } catch (error) {
    throw error;
  }
};

// Email güncelle
export const UserUpdateEmail = async (email) => {
  try {
    const response = await genericPut(`${API_URL}Person/UserUpdateEmail?email=${email}`, null);
    return response;
  } catch (error) {
    throw error;
  }
};

// Telefon güncelle
export const UserUpdatePhone = async (phone, phonecode) => {
  try {
    const response = await genericPut(`${API_URL}Person/UserUpdatePhone`, { 
      phone, 
      phoneCode: phonecode 
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Doğrulama kodunu kontrol et
export const UserUpdateVerification = async (code) => {
  try {
    const response = await genericPost(`${API_URL}Person/UserUpdateVerification?code=${code}`, null);
    return response;
  } catch (error) {
    throw error;
  }
};

// Profil resmi ekle
export const AddProfileImg = async (request) => {
  try {
    const response = await genericFilePost(`${API_URL}Person/UpdateImagesImages`, request);
    return response;
  } catch (error) {
    throw error;
  }
};

// Kimlik doğrulama
export const verifyIdentity = async (formData) => {
  try {
    const response = await genericFilePost(`${API_URL}Person/IdentityVerification`, formData);
    return response;
  } catch (error) {
    throw error;
  }
}; 